import styled from 'styled-components';
import FlightFailedImg from '../../assets/onboarding/flight-failed.svg';

const FlightFailedIcon = styled(FlightFailedImg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '37.7rem'};
  height: ${props => props.height || '13.6rem'};
  display: flex;
`;

export default FlightFailedIcon;
